import React from 'react';
import { ApplicationView, useController } from '@aha-app/mvc';
import SmartRecordsController from '../../controllers/SmartRecordsController';
import SectionTitle from './SectionTitle';
import { AhaRecord, SmartRecord } from './Record';
import styles from './smart-records-panel.module.css';
import classNames from 'classnames';

const ResultPanel: React.FC = () => {
  const controller = useController(SmartRecordsController);
  const { resultsProcessing } = controller.state;
  const { convertedRecords, failedRecords } = controller.state.recordConverter;

  if (resultsProcessing) {
    return (
      <div
        className={classNames(
          styles.panelItem,
          styles.panelItemFull,
          styles.progressContainer
        )}
      >
        <aha-loading-dots style={{ color: 'var(--aha-blue-500)' }} />
        <span className={styles.progressHeader}>Processing results</span>
      </div>
    );
  }

  return (
    <>
      <div className={styles.panelContentList}>
        {failedRecords.length > 0 && (
          <>
            <div className={classNames(styles.panelItem, 'mb-5')}>
              <SectionTitle title='Failed to convert' />
            </div>
            <div className={classNames(styles.records, styles.panelItem)}>
              {failedRecords.map(record => (
                <SmartRecord key={record.id} record={record} />
              ))}
            </div>
          </>
        )}
        {convertedRecords.length > 0 && (
          <>
            <div
              className={classNames(styles.panelItem, 'mb-5', {
                'mt-5': failedRecords.length > 0,
              })}
            >
              <SectionTitle title='Sucessfully converted' />
            </div>
            <div className={classNames(styles.records, styles.panelItem)}>
              {convertedRecords.map(record => (
                <AhaRecord key={record.id} record={record} />
              ))}
            </div>
          </>
        )}
      </div>
      <div className={classNames(styles.panelFooter, styles.panelItem)}>
        <aha-button
          kind='primary'
          type='submit'
          onClick={() => controller.actionResetPanel()}
          style={{ marginLeft: 'auto' }}
        >
          Done
        </aha-button>
      </div>
    </>
  );
};

export default ApplicationView(ResultPanel);
